import { Dialog as BaseUiDialog } from '@base-ui-components/react/dialog';
import { twMerge } from 'tailwind-merge';

import Button, { type ButtonProps } from './button';

export interface DialogCloseProps extends ButtonProps {}

function DialogClose({ children, className, ...props }: DialogCloseProps) {
  return (
    <Button
      {...props}
      className={twMerge('gooey-dialog-close', className)}
      component={BaseUiDialog.Close}
    >
      {children ?? 'Close'}
    </Button>
  );
}
DialogClose.displayName = 'GooeyDialogClose';

export default DialogClose;
